module.exports = __webpack_public_path__ + "static/media/filter-keyword.d5f379fd.svg";